import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

const WalletPaymentDialog = ({
  open,
  onClose,
  onSendManualPayment,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        zIndex: 9999,
      }}
    >
      <DialogTitle
        sx={{
          fontSize: "18px",
          fontWeight: 600,
          textTransform: "lowercase",
          pb: 1,
        }}
      >
        in-app payment unavailable
      </DialogTitle>
      <DialogContent>
        <Typography
          variant="body1"
          sx={{
            fontSize: "14px",
            textTransform: "lowercase",
            color: "#374151",
          }}
        >
          in-app payment is not available. please wait or request for a team member to capture your payment via pos/card or cash..
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            textTransform: "lowercase",
            borderRadius: 2,
            px: 3,
            py: 1,
          }}
        >
          cancel
        </Button>
        <Button
          onClick={onSendManualPayment}
          variant="contained"
          sx={{
            textTransform: "lowercase",
            borderRadius: 2,
            px: 3,
            py: 1,
            backgroundColor: "#7C3AED",
            "&:hover": {
              backgroundColor: "#6d28d9",
            },
          }}
        >
          send
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WalletPaymentDialog;
